// extracted by mini-css-extract-plugin
export default {"gridContainer":"ChallengesGrid_gridContainer__Se8C0","fadeIn":"ChallengesGrid_fadeIn__56U0O","title":"ChallengesGrid_title__f158L","cardsGrid":"ChallengesGrid_cardsGrid__noZRN"};